import React from "react";
import style from "../../../OrderInfoAviation.module.scss";
import OrdersInfoDirections from "../../OrdersInfoDirections";
import OrdersInfoCargo from "../../OrdersInfoCargo";
import CargoComment from "../../../../../orders-new/order-info-expeditor/components/CargoComment/CargoComment";

const AviationCargoTab = ({ order }) => {
  if (!order) return null;

  return (
    <div className={style.cargo_tab}>
      <OrdersInfoDirections
        item={order}
        senderName={order.senderName}
        recipientName={order.recipientName}
      />
      <OrdersInfoCargo getOrder={order} order={order} />
      <CargoComment comment={order?.details} />
    </div>
  );
};

export default AviationCargoTab;
